import {
  mapValues as _mapValues,
  isObject as _isObject,
  isString as _isString,
  isEmpty as _isEmpty,
  isNil as _isNil,
  omitBy as _omitBy,
  trim as _trim,
} from 'lodash-es';

function isEmptyObject(object) {
  return _isObject(object) && _isEmpty(object);
}

function isEmptyString(value) {
  return _isString(value) && _isEmpty(_trim(value));
}

function cleanupObject(object) {
  const newObject = _mapValues(object, (value) => {
    if (_isObject(value)) {
      return cleanupObject(value);
    }

    return value;
  });

  return _omitBy(
    newObject,
    (value) => _isNil(value) || isEmptyObject(value) || isEmptyString(value),
  );
}

const sentry = {
  dsn: process.env.VUE_APP_SENTRY,
};

const imgix = {
  domain: process.env.VUE_APP_IMGIX_DOMAIN,
  secureURLToken: process.env.VUE_APP_IMGIX_TOKEN,
};

const mapbox = {
  staticImagesApi: process.env.VUE_APP_MAPBOX_STATIC_API,
  accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
};

const gtm = {
  id: process.env.VUE_APP_GTM_ID,
  application: process.env.VUE_APP_GTM_APPLICATION,
};

const widgets = {
  interestRateDevelopment: process.env.VUE_APP_INTEREST_RATE_WIDGET_URL,
};

export const isDevelopment = process.env.VUE_APP_MODE === 'development';

export default {
  environment: process.env.VUE_APP_MODE,
  api: {
    user_data: `${process.env.VUE_APP_API_BASE}/v2/me`,
    sessions: `${process.env.VUE_APP_API_BASE}/v2/sessions`,
    deals: `${process.env.VUE_APP_API_BASE}/v2/deals/:dealUid`,
    deal_notes: `${process.env.VUE_APP_API_BASE}/v2/deals/:dealUid/notes`,
    homeday_maximum_price_popup_acknowledgments: `${process.env.VUE_APP_API_BASE}/v2/deals/:dealUid/homeday_maximum_price_popup_acknowledgments`,
    deal_tasks: `${process.env.VUE_APP_API_BASE}/v2/deals/:dealUid/tasks`,
    sign_broker_order: `${process.env.VUE_APP_API_BASE}/v2/digital_broker_order_email`,
    potential_buyers: `${process.env.VUE_APP_API_BASE}/v2/potential_buyers`,
    evaluations: `${process.env.VUE_APP_API_BASE}/v2/evaluations`,
    similar_properties: `${process.env.VUE_APP_API_BASE}/v2/similar_properties`,
    document_files: `${process.env.VUE_APP_API_BASE}/v2/document_files`,
    dashboard: `${process.env.VUE_APP_API_BASE}/v2/deal_status_groups/:dealUid`,
  },
  integrations: cleanupObject({
    sentry,
    imgix,
    mapbox,
    gtm,
    widgets,
  }),
  feature_flags: {
    edm_questionnaire: process.env.VUE_APP_EDM_QUESTIONNAIRE === 'true', // https://homeday.atlassian.net/browse/VIEW-1454
    bank_valuation: process.env.VUE_APP_BANK_VALUATION === 'true', // https://homeday.atlassian.net/browse/VIEW-1234
  },
};
